// Shared constants for answer-related components
export const POLL_SEE_RESULTS_ANSWER = 'See results'
